import { FC } from 'react';
import { IncidentDetailPatientForSendai } from 'sections/sendai/features/useIncidentDetailForSendai';
import { SendaiPatientDetailTabKey } from '../IncidentDetail';
import { BaseInfoView } from './BaseInfoView';
import { CpaModeView } from './CpaModeView';
import { RequestSummaryView } from './RequestSummaryView';
import { FindingsEmsContactView } from './FindingsEmsContactView';
import { VitalsView } from './VitalsView';
import { TreatmentView } from './TreatmentView';
import { RelatedPersonContactView } from './RelatedPersonContactView';
import { AcceptRequestHistory } from 'core/components/JianDetail/PatientDetailInfo/AcceptRequestHistory';
import { DocumentsView } from './DocumentsView';
import { ActivitySummaryView } from './ActivitySummaryView';
import { BystanderView } from './BystanderView';
import { CollaborationActivityView } from './CollaborationActivityView';
import { Photo } from 'core/components/JianDetail/PatientDetailInfo/Photo';
import { ListVideos } from 'core/components/JianDetail/PatientDetailInfo/Video';

type Props = {
  patient: IncidentDetailPatientForSendai;
  selectedTab: SendaiPatientDetailTabKey;
};

export const PatientDetailSection: FC<Props> = ({ patient, selectedTab }) => {
  return (
    <div className="pt-[24px] pb-[40px]">
      <div className="max-w-[1280px] px-[40px] m-auto flex flex-col gap-[24px]">
        {selectedTab === 'baseInfo' && (
          <BaseInfoView baseInfo={patient.baseInfo} />
        )}
        {selectedTab === 'cpaMode' && <CpaModeView cpaMode={patient.cpaMode} />}
        {selectedTab === 'requestSummary' && (
          <RequestSummaryView
            requestSummary={patient.requestSummary}
            accompanyingList={patient.baseInfo.accompanyingList}
          />
        )}
        {selectedTab === 'findingsEmsContact' && (
          <FindingsEmsContactView
            findingsEmsContact={patient.findingsEmsContact}
          />
        )}
        {selectedTab === 'bystander' && (
          <BystanderView bystander={patient.bystander} />
        )}
        {selectedTab === 'vitals' && (
          <VitalsView
            vitals={patient.vitals}
            transportBodyPosition={
              patient.requestSummary?.transportBodyPosition
            }
          />
        )}
        {selectedTab === 'collaborationActivity' && (
          <CollaborationActivityView baseInfo={patient.baseInfo} />
        )}
        {selectedTab === 'treatment' && (
          <TreatmentView treatments={patient.treatments} />
        )}
        {selectedTab === 'relatedPersonContact' && (
          <RelatedPersonContactView
            relatedPersons={patient.baseInfo.relatedPersons}
            baseInfo={patient.baseInfo}
          />
        )}
        {selectedTab === 'photo' && <Photo images={patient.imageIds} />}
        {selectedTab === 'video' && (
          <ListVideos videoList={patient.videoList} />
        )}
        {selectedTab === 'activitySummary' && (
          <ActivitySummaryView
            activitySummary={patient.requestSummary?.activitySummary}
          />
        )}
        {selectedTab === 'acceptRequestHistory' && (
          <AcceptRequestHistory
            acceptRequestHistory={patient.acceptRequestHistory}
          />
        )}
        {selectedTab === 'documents' && (
          <DocumentsView
            activityRecordPdf={patient.activityRecordPdf}
            emsReportPdf={patient.emsReportPdf}
          />
        )}
      </div>
    </div>
  );
};
